import { Accordion, AccordionItem } from '@design-system';
import { renderStoryblokRichText } from '@utils/renderStoryblokRichText';

import { FaqListStoryblok } from '../types/generated-storyblok';

interface ContentBlockFAQProps {
  blok: FaqListStoryblok;
}

export const ContentBlockFAQ = ({ blok }: ContentBlockFAQProps) => {
  return (
    <div className="mx-auto w-full max-w-lg">
      <Accordion>
        {blok.items.map((item) => {
          return (
            <AccordionItem key={item._uid} subject={item.title}>
              {renderStoryblokRichText(item.content)}
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};
